export default __webpack_public_path__ + "static/media/sort-az.90b8114e.svg";